import formInput from '@/components/common/form-input/form-input.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import { mapActions } from 'vuex'
import spinner from '@/components/common/spinner/spinner.vue'
import { formatDate } from '@/helpers/date.js'

export default {
  components: {
    formInput,
    formButton,
    spinner
  },
  data() {
    return {
      date: null,
      isSearched: false,
      isLoading: false,
      data: {
        name: null,
        email: null
      },
      list: {
        blacklist: [],
        entries: [],
        users: []
      },
      options: {
        filterable: false,
        headings: {
          name: 'Name',
          email: 'E-mail'
        },
        perPageValues: [20],
        orderBy: {
          column: 'name'
        }
      }
    }
  },
  computed: {
    isDisabled: function () {
      return !this.data.name && (!this.data.email || this.isEmailSearchedDisabled)
    },
    isEmailSearchedDisabled: function () {
      return this.data.email && this.data.email.length > 0 && this.data.email.length < 3
    },
    tables: function () {
      return {
        blacklist: {
          title: 'Blacklist emails',
          columns: ['id', 'email']
        },
        entries: {
          title: 'Entries',
          columns: ['competition_id', 'email', 'details']
        },
        users: {
          title: `Users`,
          columns: ['id', 'name', 'email']
        }
      }
    }
  },
  methods: {
    ...mapActions('user', ['checkGdpr']),
    search: async function () {
      this.isLoading = true
      try {
        const res = await this.checkGdpr(this.data)
        this.date = formatDate(new Date())
        this.list = res
        this.isSearched = true
        this.$notify({
          text: 'The search was successful',
          type: 'success'
        })
      } catch (err) {
        this.isSearched = false
        this.$notify({
          text: 'Error while searching',
          type: 'error'
        })
      }
      this.isLoading = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/gdpr/gdpr.js